import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ChatflowTemplateCreateRequest,
  ChatflowTemplateDetailResponse,
  ChatflowTemplateRequest,
  ChatflowTemplateResponse
} from '../models/chatflow.model';

@Injectable({
  providedIn: 'root'
})
export class ChatflowTemplateApiService {
  private readonly apiUrl = `${environment.apiUrl}api/chatflow-templates`;

  constructor(private http: HttpClient) {}

  getTemplates(): Observable<ChatflowTemplateResponse[]> {
    return this.http.get<ChatflowTemplateResponse[]>(this.apiUrl);
  }

  getTemplateById(id: number): Observable<ChatflowTemplateDetailResponse> {
    return this.http.get<ChatflowTemplateDetailResponse>(`${this.apiUrl}/${id}`);
  }

  /**
   * Crea una plantilla PROPIA en la biblioteca (no crea ningún chatflow). Con
   * `sourceChatflowId` copia el flujo de ese chatflow; sin él arranca con un flujo básico.
   */
  createTemplate(req: ChatflowTemplateCreateRequest): Observable<ChatflowTemplateResponse> {
    return this.http.post<ChatflowTemplateResponse>(this.apiUrl, req);
  }

  /** Edita una plantilla PROPIA. 404 si es de otra empresa, 409 si es de sistema/global. */
  updateTemplate(id: number, req: ChatflowTemplateRequest): Observable<ChatflowTemplateResponse> {
    return this.http.put<ChatflowTemplateResponse>(`${this.apiUrl}/${id}`, req);
  }

  /** Duplica una plantilla (propia o global) creando una PROPIA "<nombre> (copia)". */
  duplicateTemplate(id: number): Observable<ChatflowTemplateResponse> {
    return this.http.post<ChatflowTemplateResponse>(`${this.apiUrl}/${id}/duplicate`, {});
  }

  deleteTemplate(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
